export const VERSION = '1.0.2'
export const BUILD_DATE = '2025-06-13'

export interface VersionInfo {
  version: string
  buildDate: string
  environment: string
}

export const getVersionInfo = (): VersionInfo => ({
  version: VERSION,
  buildDate: BUILD_DATE,
  environment: typeof window !== 'undefined' && (window as any).location?.hostname?.includes('ser.vi') ? 'production' : 'development'
})
